<template>
  <v-container style="width: 800px;">
    <v-card>
      <v-container>
        <v-card-title>{{ isUpdateMode == true ? '更新' : '登録' }}</v-card-title>
        <form>
          <v-flex sm4>
            <v-text-field
              v-if="isUpdateMode"
              v-model="supplierCode"
              label="取引先コード"
              required
              disabled
            ></v-text-field>
            <v-text-field
              v-if="!isUpdateMode"
              v-model="supplierCode"
              label="取引先コード"
              v-validate="'required|max:10|alpha_num'"
              :counter="10"
              :error-messages="errors.collect('supplierCode')"
              data-vv-name="supplierCode"
              required
            ></v-text-field>
          </v-flex>
          <v-flex sm8>
            <v-text-field
              v-model="supplierName"
              label="取引先名"
              v-validate="'required|max:26'"
              :counter="26"
              data-vv-name="supplierName"
              :error-messages="errors.collect('supplierName')"
              required
            ></v-text-field>
          </v-flex>
          <v-flex sm2>
            <v-text-field
              v-model="postalCode"
              label="郵便番号"
              v-validate="'required|max:7|numeric'"
              :counter="7"
              data-vv-name="postalCode"
              :error-messages="errors.collect('postalCode')"
              hint="例）1601111"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="address"
              label="住所"
              v-validate="'required|max:33'"
              :counter="33"
              data-vv-name="address"
              :error-messages="errors.collect('address')"
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-text-field
              v-model="buildingName"
              label="ビル名"
              v-validate="'max:15'"
              :counter="15"
              data-vv-name="buildingName"
              :error-messages="errors.collect('buildingName')"
            ></v-text-field>
          </v-flex>
          <v-layout row>
            <v-flex sm4 style="    margin-top: 25px;">
              <v-text-field
                v-model="contactName"
                label="先方担当者"
                v-validate="'max:15|required'"
                :counter="15"
                data-vv-name="contactName"
                :error-messages="errors.collect('contactName')"
              ></v-text-field>
            </v-flex>
            <v-flex sm2></v-flex>
            <v-flex sm4 style="    margin-top: 25px;">
              <v-text-field
                v-model="contactInformation"
                label="連絡先"
                v-validate="'max:15'"
                :counter="15"
                data-vv-name="contactInformation"
                :error-messages="errors.collect('contactInformation')"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-flex sm4 style="    margin-top: 25px;">
            <v-text-field
              v-model="contractType"
              label="契約条件"
              v-validate="'max:5'"
              :counter="5"
              data-vv-name="contractType"
              :error-messages="errors.collect('contractType')"
            ></v-text-field>
          </v-flex>
          <v-switch
            v-if="isUpdateMode"
            v-model="isDeleted"
            label="無効にする"
            color="info"
            value="1"
            hide-details
          ></v-switch>

          <div style="height: 55px;"></div>

          <v-layout row wrap style="margin-bottom:20px;">
            <v-flex xs12 sm12>
              <v-btn
                block
                color="success"
                dark
                @click="isUpdateMode == true ? updateSupplier() : newSupplier()"
                :loading="loading2"
                :disabled="loading2"
              >
                <v-icon class="ma-2" dark small>save</v-icon>
                {{ isUpdateMode == true ? '更新' : '登録' }}する
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-container>
    </v-card>

    <div style="height: 55px;"></div>

    <v-layout row wrap>
      <v-flex xs12 sm12>
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-supplier-maintenance' }">
          <v-icon dark left>arrow_back</v-icon>戻る
        </v-btn>
      </v-flex>
    </v-layout>
    <div style="height: 55px;"></div>
  </v-container>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import ServerApiCallService from '@/services/ServerApiCallService.js'

Vue.use(VeeValidate)

export default {
  $_veeValidate: {
    validator: 'new'
  },
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    let thisObj = this
    this.supplierCode = this.$route.params.supplierCode

    if (this.supplierCode != null) {
      console.log('更新モード')
      this.isUpdateMode = true
      // getItem on udpate
      let getSupplierRequest = { supplierCode: this.supplierCode }
      ServerApiCallService.supplier(getSupplierRequest)
        .then(response => {
          console.log('completed item')
          let supplierObj = response.data.supplier
          thisObj.supplierName = supplierObj.supplierName
          thisObj.postalCode = supplierObj.postalCode
          thisObj.address = supplierObj.address
          thisObj.buildingName = supplierObj.buildingName
          thisObj.contactName = supplierObj.contactName
          thisObj.contactInformation = supplierObj.contactInformation
          thisObj.contractType = supplierObj.contractType
          thisObj.isDeleted = supplierObj.isDeleted
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    } else {
      console.log('登録モード')
      this.isUpdateMode = false
    }

    ServerApiCallService.itemCategories()
      .then(response => {
        console.log('completed item categories')
        thisObj.itemCategories = response.data.itemCategories
        // 初期表示時の
        thisObj.loading = false
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
  },
  methods: {
    // // TODO 今動かない
    // submit() {
    //   this.$validator.validateAll()
    // },
    newSupplier() {
      console.log('new supplier')
      let thisObj = this
      thisObj.loading2 = true

      // TODO 現状isDeletedがfalseの場合nullで飛ぶ
      let request = {
        supplierCode: this.supplierCode,
        supplierName: this.supplierName,
        postalCode: this.postalCode,
        address: this.address,
        buildingName: this.buildingName,
        contactName: this.contactName,
        contactInformation: this.contactInformation,
        contractType: this.contractType,
        //       isDeleted: this.isDeleted == null ? '0' : this.isDeleted
        isDeleted: '0'
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/new-supplier-maintenance'
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          thisObj.loading2 = false
          thisObj.dialog3 = true
          return
        }
        ServerApiCallService.suppliersPost(request, sendContext)
          .then(() => {
            console.log('completed new suppliers')
            thisObj.loading2 = false
            thisObj.dialog3 = true
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      })
    },
    updateSupplier() {
      console.log('update supplier')
      let thisObj = this
      thisObj.loading2 = true

      // TODO 現状isDeletedがfalseの場合nullで飛ぶ
      let request = {
        supplierCode: this.supplierCode,
        supplierName: this.supplierName,
        postalCode: this.postalCode,
        address: this.address,
        buildingName: this.buildingName,
        contactName: this.contactName,
        contactInformation: this.contactInformation,
        contractType: this.contractType,
        isDeleted: this.isDeleted == null ? '0' : this.isDeleted
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/new-supplier-maintenance'
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          thisObj.loading2 = false
          thisObj.dialog3 = true
          return
        }
        ServerApiCallService.suppliersPut(request, sendContext)
          .then(() => {
            console.log('completed new suppliers')
            thisObj.loading2 = false
            thisObj.dialog3 = true
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      })
    }
  },
  data() {
    return {
      isUpdateMode: false,

      loader: null,
      loading: true,
      loading2: false,

      supplierCode: '',
      supplierName: '',
      postalCode: '',
      address: '',
      buildingName: '',
      contactName: '',
      contactInformation: '',
      contractType: '',
      isDeleted: '0'
    }
  }
  // mounted() {
  //   this.$validator.localize('en', this.dictionary)
  // }
}
</script>
